import { Link } from 'react-router-dom';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { formatEUR } from '../../utils/money';

function formatExpenseWhen(isoDate) {
  if (!isoDate) return '';
  const date = new Date(`${isoDate}T12:00:00`);
  const now = new Date();
  now.setHours(12, 0, 0, 0);
  const isToday = date.toDateString() === now.toDateString();
  const timeFmt = new Intl.DateTimeFormat('pt-PT', { hour: '2-digit', minute: '2-digit' });
  const time = timeFmt.format(new Date(`${isoDate}T18:00:00`));
  if (isToday) return `${pt.dashboard.expenseRecent.today} ${time}`;
  return new Intl.DateTimeFormat('pt-PT', { day: 'numeric', month: 'short' }).format(date);
}

/** ds/card/expense-recent no .pen — ranking por gauge, sem tile de ícone por linha. */
export function ExpenseRecentCard({ expenses = [] }) {
  if (!expenses.length) return null;

  const copy = pt.dashboard.expenseRecent;
  const rows = expenses.slice(0, 4);
  const maxAmount = Math.max(...rows.map((exp) => Math.abs(Number(exp.amount) || 0)), 1);
  const total = rows.reduce((sum, exp) => sum + Math.abs(Number(exp.amount) || 0), 0);

  return (
    <div className="flex flex-col gap-space-3 rounded-ds-lg border border-border bg-card p-space-5 shadow-[0_6px_16px] shadow-glass-shadow/[0.12] dark:shadow-glass-shadow/[0.45]">
      <div className="flex items-center justify-between gap-space-3">
        <p className="type-section text-muted-foreground">{copy.eyebrow}</p>
        <Link to={paths.expenses} className="text-type-label font-semibold text-sage-on-tint hover:underline">
          {copy.link}
        </Link>
      </div>
      <ul className="flex flex-col">
        {rows.map((exp, index) => {
          const amount = Math.abs(Number(exp.amount) || 0);
          const gaugeWidth = Math.max(2, Math.round((amount / maxAmount) * 64));
          return (
            <li key={exp.id}>
              <div className="flex items-center gap-space-3 py-space-3">
                <div className="min-w-0 flex-1">
                  <p className="truncate text-type-body font-semibold text-card-foreground">
                    {exp.description || exp.category_name}
                  </p>
                  <p className="tnum text-type-chip font-normal text-muted-foreground">
                    {formatExpenseWhen(exp.occurred_on)}
                  </p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-space-1">
                  <p className="font-display text-type-display-row font-semibold text-card-foreground">
                    − {formatEUR(amount)}
                  </p>
                  <div className="h-1 w-16 overflow-hidden rounded-full bg-track">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-sage-500 to-sage-600"
                      style={{ width: `${gaugeWidth}px` }}
                    />
                  </div>
                </div>
              </div>
              {index < rows.length - 1 ? <div className="h-px w-full bg-border" /> : null}
            </li>
          );
        })}
      </ul>
      <div className="flex items-center justify-between gap-space-2 border-t border-border pt-space-3 text-type-label">
        <span className="font-normal text-muted-foreground">
          {copy.footLeft.replace('{count}', String(rows.length))}
        </span>
        <span className="font-semibold text-card-foreground">{formatEUR(total)}</span>
      </div>
    </div>
  );
}

export default ExpenseRecentCard;
